<ng-container *ngIf="webview$ | async as webview">
  <app-iframe
    [url]="webview.url + '&origin=' + trackingScreenName"
  ></app-iframe>
</ng-container>
